module.exports = __webpack_public_path__ + "559a48b35ac973ccf4f41c1dc7f639c1.png";